module.exports = __webpack_public_path__ + "img/laconic_talent_management.eeb6bed1.svg";